import fetchServer from "../fetchServer";


export default async function updateOrderPriceAdjustments(id,data) {
  let result = { return: 0, msg: "Something went wrong updating price adjustment!" };

  await fetchServer({
    method: "PATCH",
    url: "/product/v1/adminOtherPriceAdjustment/"+id,data,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data };
      } else result["msg"] = res?.data?.error || result["msg"];
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
